import { Provider } from '@angular/core';

import { ItTicketsApiService } from './it-tickets-api.service';
import { ItTicketsHttpService } from './it-tickets-http.service';

/**
 * Registra la implementación de `ItTicketsApiService` que usa la app.
 *
 * Los componentes piden la clase abstracta y nunca la concreta, así que
 * sustituir el cliente —por otra base de URL, por un decorador con caché— es
 * cambiar esta línea y nada más.
 */
export function provideItTickets(): Provider[] {
  return [{ provide: ItTicketsApiService, useClass: ItTicketsHttpService }];
}
